import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { Formik, Form, Field, FormikProps } from "formik";
import { Col, Row } from "react-bootstrap";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import InputDateTime from "../../../../../components/Shared/InputDateTime";

interface IFormProps {
    t?: any | undefined;
    moduleState: any;
    setQuery: any;
    visibility: any;
    onClose?: any;
}

type TInputForm = {
    fromDate: any;
    toDate: any;
};

const DEFAULT_FORM_STATE: TInputForm = {
    fromDate: null,
    toDate: null,
};

function ProviderFilter(props: IFormProps) {
    const { t, visibility } = props;
    const formRef: any = useRef();
    const [initFormState, setInitFormState] = useState<any>(DEFAULT_FORM_STATE);
    const [panelState, setPanelState] = useState<boolean>(false);

    const onSubmit = async (payloads: any) => {
        props.setQuery({
            ...props.moduleState,
            filters: payloads,
        });
    };

    const onReset = () => {
        const base: any = formRef.current;
        if (base) {
            base.resetForm();
        }
        props.setQuery({
            ...props.moduleState,
            filters: [],
        });
    };

    const onClose = () => {
        setPanelState(false);
        if (props.onClose) {
            props.onClose();
        }
    };

    useEffect(() => {
        if (visibility) {
            setPanelState(visibility);
            setInitFormState({ ...DEFAULT_FORM_STATE, ...(props.moduleState.filters ?? []) });
        }
    }, [visibility]);

    return (
        <Sidebar
            header={
                <div className="bg-body-tertiary card-header">
                    <h5 className={ "card-title mt-0" }>{ t("advance filters") }</h5>
                    <p>{ t("using filters you can archive better result.") }</p>
                </div>
            }
            visible={ panelState }
            position="left"
            onHide={ onClose }
            blockScroll={ true }
            style={ { width: "600px" } }
            closeOnEscape={ false }
        >
            <div
                style={ {
                    height: "3px",
                    background: "linear-gradient(90deg, var(--primary-color) 0%, rgba(33, 150, 243, 0) 50%)",
                } }
            ></div>
            <Formik innerRef={ formRef } enableReinitialize={ true } initialValues={ initFormState } onSubmit={ onSubmit }>
                {(formik: FormikProps<TInputForm>) => (
                    <Form onSubmit={ formik.handleSubmit }>
                        <Row className={ "mt-4 md:mb-7 sm:mb-7" }>
                            <Col sm={ 12 } md={ 6 }>
                                <Field
                                    component={ InputDateTime }
                                    name="fromDate"
                                    type={ "datetime" }
                                    label={ t("from date") }
                                    isClearable={ true }
                                    enableTimeStartOfDay
                                />
                            </Col>
                            <Col sm={ 12 } md={ 6 }>
                                <Field
                                    component={ InputDateTime }
                                    name="toDate"
                                    type={ "datetime" }
                                    label={ t("to date") }
                                    isClearable={ true }
                                    enableTimeEndOfDay
                                />
                            </Col>
                        </Row>
                        <div className="filter filter-card-footer" style={ { width: "585px" } }>
                            <Button type={ "submit" } disabled={ formik.isSubmitting } size={ "small" } outlined>
                                <i className="pi pi-filter me-2" />
                                { t("filter") }
                            </Button>
                            <Button
                                type={ "button" }
                                disabled={ formik.isSubmitting }
                                onClick={ onReset }
                                className={ "ms-2" }
                                size={ "small" }
                                severity={ "warning" }
                                outlined
                            >
                                <i className="pi pi-refresh me-2" />
                                { t("reset") }
                            </Button>
                            <Button
                                type={ "button" }
                                disabled={ formik.isSubmitting }
                                onClick={ onClose }
                                className={ "ms-2" }
                                size={ "small" }
                                severity={ "danger" }
                                outlined
                            >
                                <i className="pi pi-arrow-left me-2" />
                                { t("close") }
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </Sidebar>
    );
}

export default withTranslation()(ProviderFilter);
